<template>
  <v-container
    id="productTemplateDetailEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Section"
          item-text="templateSection"
          item-value="id"
          bind-text="templateSection"
          bind-value="productTemplateSectionId"
          :bind-item="editedItem"
          :error-messages="safeFormErrors.ProductTemplateSectionId"
          :fetch-method="getSections"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="editedItem.question"
          :error-messages="safeFormErrors.Question"
          label="Question"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-select
          v-model="editedItem.answerDataType"
          label="Data Type"
          :items="dataTypes"
          :error-messages="safeFormErrors.AnswerDataType"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.answerRequired"
          :error-messages="safeFormErrors.AnswerRequired"
          label="Required"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          v-model="editedItem.questionScreenWidth"
          label="Screen Width"
          :items="screenWidth"
          :error-messages="safeFormErrors.QuestionScreenWidth"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.orderNo"
          :error-messages="safeFormErrors.OrderNo"
          label="Order"
          type="number"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'ProductTemplateDetailEdit',

    props: {
      value: {
        type: Object,
        default: null,
      },
      productTemplateId: {
        type: Number,
        default: null,
      },
      defaultSectionId: {
        type: Number,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,

      dataTypes: ['string', 'number', 'date', 'boolean'],
      screenWidth: [
        { text: 'Quarter', value: 1 },
        { text: 'Half', value: 2 },
        { text: 'Three Quarter', value: 3 },
        { text: 'Full', value: 4 },
      ],

      productTemplateSectionResource: new TroodyApi('productTemplateSection/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = (this.value || {})
        if (!this.editedItem.id && this.defaultSectionId) {
          this.editedItem.productTemplateSectionId = this.defaultSectionId
        }
      },

      getSections () {
        return this.productTemplateSectionResource.query({ productTemplateId: this.productTemplateId })
      },

      onChange () {
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
